// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__pMBCS","fileBtn":"File_fileBtn__2wzq-","closeBtn":"File_closeBtn__293Mq","fileSelected":"File_fileSelected__34Zj6","disabled":"File_disabled__3WP5g"};